// API information
export const LOCAL_API_URL = 'http://localhost:3000/api';
export const PROD_API_URL = 'https://api-refactor.mchacks.ca/api';

// Cache information
export const CACHE_USER_KEY = 'userInfo';
export const CACHE_HACKER_KEY = 'hackerInfo';
export const CACHE_STATS_KEY = 'statsInfo';
export const CACHE_SPONSOR_KEY = 'sponsorInfo';
export const CACHE_TRAVEL_KEY = 'travelInfo';
export const CACHE_SETTINGS_KEY = 'settingsInfo';

// General information
export const HACKATHON_NAME = 'McHacks';
export const HACKATHON_DESCRIPTION = `Create, build, and play with us at ${HACKATHON_NAME}, Canada's favourite hackathon, hosted at McGill University.`;
export const HACKATHON_DATE = 'February 1-2, 2020';
export const HACKATHON_LOCATION = 'McGill University';
export const STATIC_SITE = 'https://mchacks.ca';

// Travel information
export const BUS_DEPARTURE_CITY = 'Toronto';
export const BUS_GENERAL_INFO = `We're offering a round-trip bus from ${BUS_DEPARTURE_CITY} to ${HACKATHON_NAME}. Seats are available on a first-come, first-serve basis. You can place a deposit to secure a seat on the bus`;
export const BUS_SHOPIFY_PAGE = 'https://bus.mchacks.ca/';
export const BUS_SLACK_PAGE =
  'https://join.slack.com/t/mchacks7/shared_invite/enQtOTA3MDc2NDU4OTAyLTI0ZWU1N2VkOGExZTA3NDg3Y2JiMGE3MGE2ZmU4MGRlYjI3YmZlYjAxYmI0OTk2ZjZjYTE0ZjNhYmY0ZDNmZmU';
export const BUS_SLACK_CHANNEL = '#bus-toronto channel';
export const TRAVEL_POLICY =
  'https://docs.google.com/document/d/1K8WSGQtWfKrybT_O9WrxIp93dETrv3jhy71fkHKZwdM';
export const TRAVEL_RECEIPTS_FORM = 'https://forms.gle/TdxUaUn31WzXcPvu6';

// Social media
export const FACEBOOK_EVENT_URL =
  'https://www.facebook.com/events/1086921742114789';
export const TWITTER = '@mcgillhacks';

// SEO
export const RICH_PREVIEW_IMAGE =
  'https://2019.mchacks.ca/static/mchacks-og.png';

// Credentials information
export const EMAIL_LABEL = 'Email';
export const PASSWORD_LABEL = 'Password';

// Required label
export const REQUIRED_DESCRIPTION =
  'Required fields are denoted with an asterisk (*)';

// Account management
export const OLD_PASSWORD_LABEL = 'Old password';
export const NEW_PASSWORD_LABEL = 'New password';
export const DIETARY_RESTRICTIONS_LABEL = 'Dietary restrictions';
export const PRONOUN_LABEL = 'Pronouns';
export const PRONOUN_PLACEHOLDER = 'Pronouns';
export const GENDER_LABEL = 'Gender';
export const GENDER_PLACEHOLDER = 'Gender';
export const PHONE_NUMBER_LABEL = 'Phone number';
export const BIRTH_DATE_LABEL = 'Birth date';
export const FIRST_NAME_LABEL = 'First name';
export const LAST_NAME_LABEL = 'Last name';

// Status management
export const NONE_STATUS_HEADING = "Let's get started";
export const NONE_STATUS_TEXT =
  'You’re all set! Ready to start your application?';
export const APPLIED_STATUS_HEADING = "You've applied to McHacks!";
export const APPLIED_STATUS_TEXT =
  'Keep an eye on your email for when decisions come out. ';
export const SOCIAL_MEDIA_PROMPT_START = 'Follow us on ';
export const SOCIAL_MEDIA_PROMPT_END = ' for the latest updates.';
export const ACCEPTED_STATUS_HEADING = 'Confirm your spot';
export const ACCEPTED_STATUS_TEXT =
  "Congratulations! We're excited to offer you a spot at McHacks!";
export const RSVP_DEADLINE_TEXT_START = 'Please RSVP by';
export const RSVP_DEADLINE_TEXT_END =
  "to secure your spot and we'll see you there.";
export const DECLINED_STATUS_TEXT =
  "Thank you so much for your interest in McHacks. Unfortunately, we don't have enough space to offer you a spot this year. That being said, please keep in touch and we'd love to see you apply again next year! In the meantime, we hope you continue to create and build awesome things!";
export const WAITLISTED_STATUS_TEXT =
  "Thank you so much for your interest in McHacks. At the moment, we've placed you on the waitlist. We received many great applications this year and wish we had the capacity accept them all. Currently, we can only place you on the waitlist, but please keep an eye on the dashboard to see if your status changes and a spot opens up!";
export const CONFIRMED_STATUS_TEXT =
  'Your attendance has been confirmed! More information on McHacks will be sent to your email as we get closer to the event.';
export const WITHDRAWN_STATUS_TEXT =
  "We're sorry to hear you're unable to make it to McHacks this year. Please keep in touch and hopefully we'll see you at the next one.";
export const CHECKED_IN_STATUS_HEADING = 'Welcome to McHacks!';
export const CHECKED_IN_STATUS_TEXT = 'You’re checked-in and ready to go.';

// Application management
export const DEADLINE_PASSED_LABEL =
  'Sorry, we are no longer accepting applications at this time.';
export const DECISION_DEADLINE_PASSED_LABEL =
  'Sorry, the deadline to RSVP has passed. We are no longer accepting applications at this time.';
export const BARRIERS_LABEL = 'Would you require any accommodations?';
export const BUS_REQUEST_LABEL = 'Will you require a seat on a bus?';
export const BUS_REQUEST_SUBTITLE =
  'We will be sending busses to Toronto, Waterloo, London, Ottawa, Kingston, and Boston.';
export const COC_ACCEPTANCE_PHRASE = 'I accept the';
export const COC_MCHACKS_REQUEST_LABEL = 'McHacks Code of Conduct';
export const COC_MLH_REQUEST_LABEL = 'MLH terms, conditions and guidelines.';
export const COMMENTS_LABEL = "Is there anything you'd like us to know?";
export const DEGREE_LABEL = 'Degree';
export const DEGREE_PLACEHOLDER = 'High School, Undergraduate...';
export const DRIBBBLE_LINK_LABEL = 'Dribbble URL';
export const DRIBBBLE_LINK_PLACEHOLDER = 'https://dribbble.com/';
export const QUESTION1_REQUEST_LABEL = 'Why McHacks?';
export const QUESTION2_REQUEST_LABEL = 'What are you passionate about?';
export const ETHNICITY_LABEL = 'Ethnicity';
export const ETHNICITY_PLACEHOLDER = 'Ethnicity';
export const GITHUB_LINK_LABEL = 'GitHub URL';
export const GITHUB_LINK_PLACEHOLDER = 'https://www.github.com/';
export const GRADUATION_YEAR_LABEL = 'Graduation Year';
export const IMPAIRMENTS_LABEL =
  'Do you have any hearing and/or visual impairments?';
export const JOBINTEREST_LABEL = 'Job Interest';
export const JOBINTEREST_PLACEHOLDER = 'Full Time, Internship, None...';
export const LINKEDIN_LINK_LABEL = 'LinkedIn URL';
export const LINKEDIN_LINK_PLACEHOLDER = 'https://linkedin.com/in/';
export const FIELD_OF_STUDY_PLACEHOLDER = 'Field of Study';
export const FIELD_OF_STUDY_LABEL = 'Field of Study';
export const OTHER_LINK_LABEL = 'Other URL';
export const OTHER_LINK_PLACEHOLDER = 'https://my.website.com/';
export const MCHACKS_COC = 'Code of Conduct';
export const MCHACKS_PRIVACY = 'Privacy Policy';
export const MLH_LABEL = 'I accept the MLH policies.';
export const PERSONAL_LABEL = 'Personal URL';
export const RESUME_LABEL = 'Resume';
export const SHIRT_SIZE_LABEL = 'Shirt Size (Unisex)';
export const ATTENDENCE_OPTION_PREFERENCE_LABEL =
  'Would you prefer to attend McHacks in person or virtually?';
export const SKILLS_LABEL = 'Skills';
export const SKILLS_PLACEHOLDER = 'Javascript, iOS, Android...';
export const SCHOOL_LABEL = 'School';
export const SCHOOL_PLACEHOLDER = 'School';
export const TRAVEL_LABEL = 'Travel';
export const TRAVEL_REQUEST_LABEL =
  'Will you require any travel reimbursement? (up to $100)';
export const PREVIOUS_HACKATHONS_LABEL =
  'How many hackathons have you been to?';
export const REVIEW_APPLICIATION_DESCRIPTION =
  'Your are about to submit. Please review your application before submitting. You won’t be able to edit your responses later.';

// Invite Page
export const ACCOUNT_TYPE_LABEL = 'Account type';

// Application Page
export const TOTAL_PAGES = 5;

// Dashboard page
export const ACCOUNT_NOT_CONFIRMED_MSG = 'You must confirm your account!';
export const RESEND_CONF_EMAIL = 'Resend confirmation email';
export const EMAIL_SENT = 'Email sent!';

// LabelTextComponent page
export const REQUIRED_INPUT = '*';
export const OPTIONAL_INPUT = '(optional)';

// Team page
export const TEAM_OVERVIEW =
  'Form a team with up to 3 other friends in order to have your applications considered as a group.';
export const TEAM_NAME = 'Team name:';
export const TEAM_NAME_SUBTITLE =
  'Other hackers can join your team with this string.';
export const TEAM_MEMBERS = 'Team members:';
export const TEAM_MAX_SIZE = 'Max 4 Hackers';

// Sponsor creation
export const SPONSOR_COMPANY_LABEL = 'Company name';
export const SPONSOR_CONTRACT_URL_LABEL = 'Contract URL';
export const SPONSOR_NOMINEE_LABEL = 'Nominees';

// Settings management page
export const SETTINGS_OPEN_TIME_LABEL = 'Applications open at:';
export const SETTINGS_CLOSE_TIME_LABEL = 'Applications close at:';
export const SETTINGS_CONFIRM_TIME_LABEL = 'Hacker confirmations close at:';
export const SETTINGS_IS_REMOTE_LABEL = 'Remote hackathon mode';

// Sentry
export const SENTRY_DSN =
  'https://26f1d8550cc34833b9e04894a8192611@o659380.ingest.sentry.io/5764002';
